export { DrillFooterPronunciationView } from "#pronunciation-view";
